import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Login from './Auth/Login';
import Logout from './Auth/Logout';
import Callback from './Auth/Callback';
import ProtectedRoute from './Auth/ProtectedRoute';
import Admin from '../src/components/Global/Admin';
import SecurityHeaders from './components/SecurityHeaders';

const App = () => (
  <>
    <SecurityHeaders />
    <Switch>
      <Redirect exact from="/index.html" to="/" />
      <Route exact path="/" component={Login} />
      <Route path="/callback" component={Callback} />
      <Route path="/logout" component={Logout} />
      <ProtectedRoute path="/admin" component={Admin} />
      <Redirect to="/" />
    </Switch>
  </>
);

export default App;
